<template>
  <footer class="footer">
    <div class="footer-copy">
      <img src="@/assets/images/flogo.svg" alt=""/>
      <p>©2021, RTE. All rights reserved   <a target="_block" href="https://beian.miit.gov.cn/#/Integrated/index">沪ICP备14053584号-15</a></p>
    </div>
    <div class="footer-address">
      <div class="address-item" v-for="item in addressData" :key="item.id">
        <span>{{item.title}}</span>
        <strong>{{item.name}}</strong>
        <p><b>{{item.tel}}</b><i>{{item.email}}</i></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      addressData: [
        {
          id: '01',
          title: '媒体合作',
          name: '李先生',
          tel: '17521747872',
          email: 'liying@agora.io'
        },
        {
          id: '02',
          title: '票务咨询',
          name: '刘女士',
          tel: '13911327164',
          email: 'liuhuinu@agora.io'
        },
        {
          id: '03',
          title: '商务合作',
          name: '李女士',
          tel: '18510826521',
          email: 'lijingyi@agora.io'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
  @import url("@/assets/css/common/index.less");
</style>